module.exports = __webpack_public_path__ + "img/mecha-4.7b47204d.jpg";